import { Log } from "./log";

export class RemoteHelper {

  public static decToHexString(decimal): string {

    let hexString = (parseInt(decimal)).toString(16);
    return hexString.toUpperCase();
  }

  public static hexStringToDec(hexString): number {

    let decimal = parseInt(hexString, 16);
    return decimal;
  }

  public static changeOrder(data: string) {

    let outputString = "";
    outputString += (data.charAt(0));
    outputString += (data.charAt(3));
    outputString += (data.charAt(4));
    outputString += (data.charAt(1));
    outputString += (data.charAt(2));

    return outputString;
  }

  // TEST--> 0020AF4A
  // OK ---> 0020a4af


  //dal codice leggibile a quello "cifrato"
  public static jcmCodeToStandardCode(jcmCode: string): string {

    if(jcmCode.length == 5){
      jcmCode = "0" + jcmCode;
    }

    let hexString = this.decToHexString(jcmCode);

    if(hexString.length == 4){
      hexString = "0" + hexString;
    }
    return "002" + this.changeOrder(hexString);
  }

  //dal codice "cifrato" a quello leggibile
  public static standardCodeToJcmCode(code: string): number {
    // tolgo gli 002 iniziali
    let codeSliced = code.slice(3, code.length);

    let decString = this.changeOrder(codeSliced);

    return this.hexStringToDec(decString);
  }
}
